import {createAction, props} from '@ngrx/store';
import {CreateDefaultEntitiesModel} from '@spout/global-any/models';

export const createDefaultConfigsToFirestore = createAction(
  '[Onboarding/API] Create Default Configs',
  props<CreateDefaultEntitiesModel>()
);
